export default [
  [`Размеры`, `M`, `L`, `XL`, `2XL`, `3XL`],
  [`Российский размер`, `48`, `50`, `52`, `54`, `56`],
  [`Рост`, `176`, `182`, `182`, `182`, `182`],
  [`Объем груди(a)`, `96`,`100`, `104`, `108`, `112`],
  [`Обхват талии (b)`, `80`, `84`, `88`, `92`, `96`],
  [`Ширина изделия по груди (c)`, `45`, `48`, `50`, `52`, `56` ],
  [`Длина изделия (d)`, `68`, `69`, `71`, `72`, `75`]
];
